import { LoggerLoggingLevelEnum } from '../app/services/logger/logger.service';

export const environment = {
  production: true,
  loggerLevel: LoggerLoggingLevelEnum.All,
  vuUrl: 'https://gastro-demo-vu.maxcrc.de',
  odooUrl: 'https://gastro-demo.maxcrc.de',
  odooDatabaseName: 'gastrodemo',
  odooPaymentControllerUrl: '/payment-v21/kiosk-order',
  globalSettings: null,
  contactFormUrl: '/contact',
  linkLocationCSS: 'static/theme/wanzl_gastro/css/wanzl_gastro_styles.css',
  theme: 'wanzl',
  srcVideo: '',
  availableLangs: ['de-DE', 'en-US'],
  internalEventInfoLink: '',
  useVirtualKeyboard: true,
  title: 'Wanzl Kantin Demo',
  faviconUrl: '/kantin/static/src/img/favicon.ico',
  smartCardUrl: 'https://smart-card.maxcrc.de',
  shopMode: '',
};
